import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

/** CardFooter is  */
const CardFooter = props => {
  const { className, children, ...other } = props;

  return (
    <div className={clsx("em-c-card__footer", className)} {...other}>
      {children}
    </div>
  );
};

CardFooter.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** React component children */
  children: PropTypes.node
};

CardFooter.defaultProps = {
  className: "",
  children: null
};

export default CardFooter;
